/*
 * Copyright (c) 2022-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { FieldElement, UISchemaLayout } from '../types';

export const removeFieldLevelMessages = (
  elements: UISchemaLayout['elements'],
): UISchemaLayout['elements'] => elements.map((el) => {
  if (el.type === 'Field') {
    // @ts-ignore - add type in authjs Input
    // eslint-disable-next-line no-param-reassign
    delete (el as FieldElement).options.inputMeta.messages;
  }
  return el;
});
